export function createAllPins(rows, width) {
  let allPins = [];

  let vd, hd, pinR, ballR;
  switch (rows) {
    case 16:
      vd = 21; // 7px
      hd = 18; // 6px
      pinR = 2; // 3
      ballR = 4;
      break;
    case 15:
      vd = 21.5; // 7
      hd = 18; // 6
      pinR = 2.5; // 3.5
      ballR = 4;
      break;
    case 14:
      vd = 24; // 7.5
      hd = 18; // 6
      pinR = 2.5; // 4
      ballR = 4;
      break;
    case 13:
      vd = 26; // 8.5
      hd = 21; // 7
      pinR = 3; // 4
      ballR = 5;
      break;
    case 12:
      vd = 28; // 9.5
      hd = 22.5; // 7.5
      pinR = 3.2; // 4
      ballR = 5.5;
      break;
    case 11:
      vd = 30; // 11.5
      hd = 25; // 9
      pinR = 3.5; // 4.5
      ballR = 6;
      break;
    case 10:
      vd = 32; // 13
      hd = 26; // 10
      pinR = 3.5; // 5
      ballR = 6;
      break;
    case 9:
      vd = 36; // 13
      hd = 26; // 10
      pinR = 4; // 5
      ballR = 7;
      break;
    case 8:
      vd = 38; // 15
      hd = 29; // 11.5
      pinR = 4; // 5.5
      ballR = 7;
      break;

    default:
      break;
  }

  for (let i = 0; i <= rows; i++) {
    allPins.push([]);
  }
  for (let i = 0; i <= rows; i++) {
    let first = width / 2 - (hd / 2) * (i + 1);
    for (let o = 0; o < i + 3; o++) {
      allPins[i].push({
        x: first + o * hd - hd / 2,
        y: vd * (i + 1),
        r: pinR,
        vd,
        ballR,
      });
    }
  }
  return allPins;
}

// const = 39 - (18 / 8) * (rows - 8); // vertical distance between pins
// const hd = 35 - (18 / 8) * (rows - 8) - 2; // horizontal distance between pins
// // const pinR = 8 - (5 / 8) * (rows - 8); // pin radius
// const pinR = 8 - (5 / 8) * (rows - 8); // pin radius
